import { useMutation } from '@tanstack/react-query';
import type { CandidateProfileInterviewLogUpdateRequest } from '../types/CandidateProfile';

export default function useUpdateCandidateInterviewLog() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      candidateProfileId,
      interviewLogId,
      title,
      interviewed_at,
      organization_user_id,
      custom_data,
    }: CandidateProfileInterviewLogUpdateRequest) => {
      const response = await fetch(
        `/agent/api/candidate_profiles/${candidateProfileId}/candidate_interview_logs/${interviewLogId}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({ title, interviewed_at, organization_user_id, custom_data }),
        }
      );

      if (!response.ok) {
        throw new Error('面談情報の更新に失敗しました');
      }

      const data = await response.json();
      return data;
    },
  });
}
